// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"7b34a7d2","453":"3031488b","459":"23ee4622","470":"1bdb00d3","510":"90894c7b","648":"110546f8","680":"ccb6953e","939":"ed512a77"}[chunkId] + ".chunk.js";
};